import React from "react";
import cx from 'classnames';
import { Modal, Button } from "react-bootstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import Loader from "../../Loader/Loader";
import cs from '../../../components/commonStyle.css';
import s from './CustomConfirmModal.css';

const CustomConfirmModal = (props) => {
    const { showModel, children, title, bodyText, closeModal, popupButtonLeftFunction, popupButtonLeftName, load, loaderActionBtnText, loaderConfirmActionFunction, popupButtonRightName, popupButtonRightFunction, modalData } = props;

    return (
        <Modal show={showModel} onHide={closeModal} dialogClassName='commonModalContainer globalModalContainer'>
            <Modal.Header className='commonModalHeader' closeButton>
                <Modal.Title className='commonModalTitle'>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body bsClass='commonModalBody'>
                {children}
                {bodyText && <p className={s.confirmationPopupBodyText}>{bodyText}</p>}

                {(popupButtonLeftName || loaderActionBtnText || popupButtonRightName) &&
                    <div className={cx('doubleBtnFlexEnd', cs.spaceTop4)}>
                        {popupButtonLeftName &&
                            <Button className={cs.btnPrimaryBorder} onClick={popupButtonLeftFunction}>
                                {popupButtonLeftName}
                            </Button>}

                        {loaderActionBtnText &&
                            <Loader
                                type={"button"}
                                handleClick={loaderConfirmActionFunction && (() => loaderConfirmActionFunction(modalData)) }
                                show={load}
                                label={loaderActionBtnText}
                                className={cx(cs.btnPrimary, 'loaderButtonFlex')}
                            />
                        }

                        {popupButtonRightName &&
                            <Button className={cs.btnPrimary} onClick={popupButtonRightFunction}>
                                {popupButtonRightName}
                            </Button>
                        }
                    </div>
                }
            </Modal.Body>
        </Modal>
    )
}

export default withStyles(cs, s)(CustomConfirmModal);